import { render, staticRenderFns } from "./dragFileView.vue?vue&type=template&id=05ae7af7&scoped=true&"
import script from "./dragFileView.vue?vue&type=script&lang=js&"
export * from "./dragFileView.vue?vue&type=script&lang=js&"
import style0 from "./dragFileView.vue?vue&type=style&index=0&id=05ae7af7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae7af7",
  null
  
)

export default component.exports